<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="itemClassesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeItemClassesField] ? 'Exclude' : 'Include')} Item Classes`"
      :options="itemClasses.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      bottom-slots
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one item class'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeItemClassesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'ItemClassesConditionForm',
  configuration: ['itemClasses'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    itemClassesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.ITEM_CLASSES
    },
    excludeItemClassesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_ITEM_CLASSES
    }
  }
}

</script>
